// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-AppHistory-Preview-DistributionDetails-DistributionDetails-module__container--39V58"};